import { useMemo } from 'react';
import { useSettings } from '@wu/widget-core';
import { getVisibleJobs } from '../filters/utils';

export function useVisibleJobs() {
  const { jobs } = useSettings();
  return useMemo(() => getVisibleJobs(jobs), [jobs]);
}
